export default class Experience
{
  constructor(titles, descriptions, photo) 
  {
    // {} instead of array to support stringify
    this.titles = titles;
    this.descriptions = descriptions;

    this.photo = photo;
  }    

  isValid()
  {
    var result = true;

    for (const [key, value] of Object.entries(this.titles)) { if(!value) { result = false; break; } } // Titles
    if(result) for (const [key, value] of Object.entries(this.descriptions)) { if(!value) { result = false; break; } } // Descriptions
    
    if(result) result = this.photo;
    
    return result;
  }
}